import _classCallCheck from "/mnt/ramdisk/app/solvuu-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/mnt/ramdisk/app/solvuu-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import { updateClusterID } from './utils';
var distanceSymbol = Symbol('distance');

var KMeansResult =
/*#__PURE__*/
function () {
  /**
   * Result of the kmeans algorithm
   * @param {Array<number>} clusters - the cluster identifier for each data dot
   * @param {Array<Array<object>>} centroids - the K centers in format [x,y,z,...], the error and size of the cluster
   * @param {boolean} converged - Converge criteria satisfied
   * @param {number} iterations - Current number of iterations
   * @param {function} distance - (*Private*) Distance function to use between the points
   * @constructor
   */
  function KMeansResult(clusters, centroids, converged, iterations, distance) {
    _classCallCheck(this, KMeansResult);

    this.clusters = clusters;
    this.centroids = centroids;
    this.converged = converged;
    this.iterations = iterations;
    this[distanceSymbol] = distance;
  }
  /**
   * Allows to compute for a new array of points their cluster id
   * @param {Array<Array<number>>} data - the [x,y,z,...] points to cluster
   * @return {Array<number>} - cluster id for each point
   */


  _createClass(KMeansResult, [{
    key: "nearest",
    value: function nearest(data) {
      var clusterID = new Array(data.length);
      var centroids = this.centroids.map(function (centroid) {
        return centroid.centroid;
      });
      return updateClusterID(data, centroids, clusterID, this[distanceSymbol]);
    }
    /**
     * Returns a KMeansResult with the error and size of the cluster
     * @ignore
     * @param {Array<Array<number>>} data - the [x,y,z,...] points to cluster
     * @return {KMeansResult}
     */

  }, {
    key: "computeInformation",
    value: function computeInformation(data) {
      var enrichedCentroids = this.centroids.map(function (centroid) {
        return {
          centroid: centroid,
          error: 0,
          size: 0
        };
      });

      for (var i = 0; i < data.length; i++) {
        enrichedCentroids[this.clusters[i]].error += this[distanceSymbol](data[i], this.centroids[this.clusters[i]]);
        enrichedCentroids[this.clusters[i]].size++;
      }

      for (var j = 0; j < this.centroids.length; j++) {
        enrichedCentroids[j].error /= enrichedCentroids[j].size;
      }

      return new KMeansResult(this.clusters, enrichedCentroids, this.converged, this.iterations, this[distanceSymbol]);
    }
  }]);

  return KMeansResult;
}();

export { KMeansResult as default };